{
  "version": 1,
  "asset_id": "82042bb9-4372-445d-adda-b9d7fec06de4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/82042bb9-4372-445d-adda-b9d7fec06de4/hiatal-type-2-story-preparation-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/82042bb9-4372-445d-adda-b9d7fec06de4/hiatal-type-2-story-preparation-800.webp",
  "original_filename": "hiatal-type-2-story-preparation-800.webp",
  "size": 42436,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:01Z"
}
